import type { Settings } from '@wellread/api';

/**
 * Applies the chrome theme and colour theme to <html>. "system" follows the
 * OS; Ink, the default accent, needs no attribute (tokens.css recolours the
 * accent under [data-accent]). The web app has one density; the stored
 * density setting is for the native apps, where it follows the platform.
 */
export function applyChrome(s: Settings['chrome']): void {
  const root = document.documentElement;
  if (s.theme === 'system') delete root.dataset.theme;
  else root.dataset.theme = s.theme;
  if (s.accent === 'ink') delete root.dataset.accent;
  else root.dataset.accent = s.accent;
}
